import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import {AuthProvider} from './context/AuthContext';
import {ProtectedRoute} from './components/ProtectedRoute';
import {PermissionRoute, HomeRedirect} from './components/PermissionRoute';
import {Toaster} from 'sonner';
import Login from './pages/Login';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import RestaurantsEnhanced from './pages/RestaurantsEnhanced';
import RestaurantProfile from './pages/RestaurantProfile';
import Users from './pages/Users';
import DeliveryAgents from './pages/DeliveryAgents';
import Categories from './pages/Categories';
import Banners from './pages/Banners';
import Offers from './pages/Offers';
import './App.css';
import Zones from './pages/zone';
import Orders from './pages/Orders';
import AgentLocations from './pages/AgentLocations';
import Roles from './pages/Roles';
import Admins from './pages/Admins';
import Notifications from './pages/Notifications';
import ExploreMore from './pages/ExploreMore';
import Transactions from './pages/Transactions';
import AffiliateSystem from './pages/AffiliateSystem';
import Settings from './pages/Settings';
import Reviews from './pages/Reviews';
import ReferEarn from './pages/ReferEarn';
import CommissionManagement from './pages/CommissionManagement';
import AppIcon from './pages/AppIcon';
import LaunchScreen from './pages/LaunchScreen';

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster position="top-right" richColors/>
                <Routes>
                    <Route path="/login" element={<Login/>}/>
                    <Route
                        path="/"
                        element={
                            <ProtectedRoute>
                                <Layout/>
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<HomeRedirect/>}/>
                        <Route path="dashboard" element={<PermissionRoute resource="dashboard"><Dashboard/></PermissionRoute>}/>
                        <Route path="restaurants" element={<PermissionRoute resource="restaurants"><RestaurantsEnhanced/></PermissionRoute>}/>
                        <Route path="restaurants/:id/profile" element={<PermissionRoute resource="restaurants"><RestaurantProfile/></PermissionRoute>}/>
                        <Route path="users" element={<PermissionRoute resource="users"><Users/></PermissionRoute>}/>
                        <Route path="delivery-agents" element={<PermissionRoute resource="delivery_agents"><DeliveryAgents/></PermissionRoute>}/>
                        <Route path="agent-locations" element={<PermissionRoute resource="agent_locations"><AgentLocations/></PermissionRoute>}/>
                        <Route path="roles" element={<PermissionRoute resource="roles"><Roles/></PermissionRoute>}/>
                        <Route path="admins" element={<PermissionRoute resource="admins"><Admins/></PermissionRoute>}/>
                        <Route path="notifications" element={<PermissionRoute resource="notifications"><Notifications/></PermissionRoute>}/>
                        <Route path="explore-more" element={<PermissionRoute resource="explore_more"><ExploreMore/></PermissionRoute>}/>
                        <Route path="categories" element={<PermissionRoute resource="categories"><Categories/></PermissionRoute>}/>
                        <Route path="banners" element={<PermissionRoute resource="banners"><Banners/></PermissionRoute>}/>
                        <Route path="offers" element={<PermissionRoute resource="offers"><Offers/></PermissionRoute>}/>
                        <Route path="zones" element={<PermissionRoute resource="zones"><Zones/></PermissionRoute>}/>
                        <Route path="orders" element={<PermissionRoute resource="orders"><Orders/></PermissionRoute>}/>
                        <Route path="transactions" element={<PermissionRoute resource="transactions"><Transactions/></PermissionRoute>}/>
                        <Route path="affiliate-system" element={<PermissionRoute resource="affiliate"><AffiliateSystem/></PermissionRoute>}/>
                        <Route path="reviews" element={<PermissionRoute resource="reviews"><Reviews/></PermissionRoute>}/>
                        <Route path="refer-earn" element={<PermissionRoute resource="referrals"><ReferEarn/></PermissionRoute>}/>
                        <Route path="commission-management" element={<PermissionRoute resource="commissions"><CommissionManagement/></PermissionRoute>}/>
                        <Route path="app-icon" element={<PermissionRoute resource="app_icons"><AppIcon/></PermissionRoute>}/>
                        <Route path="launch-screen" element={<PermissionRoute resource="launch_screen"><LaunchScreen/></PermissionRoute>}/>
                        <Route path="settings" element={<PermissionRoute resource="settings"><Settings/></PermissionRoute>}/>
                    </Route>
                    <Route path="*" element={<Navigate to="/" replace/>}/>
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;